import { debug } from "console";
import { ArmVisual } from "../../../visuals/ArmVisual";
import { ModelBasedVisual } from "../../../visuals/ModelBasedVisual";
import { AgentEvents, BaseAgent } from "../agents/BaseAgent";
import { RobotAgent } from "./RobotAgent";

export class ArmAgent extends BaseAgent {
  constructor(visual: ArmVisual) {
    super(visual);
    if (visual.parentId) {
      const robotVisual = this.visual.wr.dataService.visuals.get(visual.parentId) as ModelBasedVisual;
      if (robotVisual && robotVisual.agent) {
        const robotAgent = robotVisual.agent as RobotAgent;
        console.log('Found parent robot agent', robotAgent.visual._id);
        robotAgent.on(AgentEvents.StateChange, (dgram) => {
          if (dgram.poi) {
            console.log('Moving arm to', dgram.poi);
            if (dgram.poi.position !== undefined) {
              visual.moveArm(dgram.poi.position);
            } else {
              visual.resetArm();
            }
          }
        });
      }
    }
  }

}